
import { TranslationSet } from '../types';

export const premium: TranslationSet = {
  'premium.title': {
    en: 'Premium',
    ja: 'プレミアム',
    es: 'Premium',
    zh: '高级版',
    fa: 'حساب ویژه'
  },
  'premium.subtitle': {
    en: 'Choose the plan that\'s right for you',
    ja: 'あなたに合ったプランを選択',
    es: 'Elige el plan que mejor se adapte a ti',
    zh: '选择适合您的计划',
    fa: 'طرحی را انتخاب کنید که مناسب شما است'
  },
  'premium.unlockUnlimited': {
    en: 'Unlock Unlimited Entries and More!',
    ja: '無制限のエントリーなどをアンロック！',
    es: 'Desbloquea entradas ilimitadas y más!',
    zh: '解锁无限条目和更多！',
    fa: 'دسترسی به یادداشت‌های نامحدود و بیشتر!'
  },
  'premium.allFeatures': {
    en: 'Access all premium features and remove limitations.',
    ja: 'すべてのプレミアム機能にアクセスし、制限を解除します。',
    es: 'Accede a todas las funciones premium y elimina las limitaciones.',
    zh: '访问所有高级功能并解除限制。',
    fa: 'به تمام ویژگی‌های حساب ویژه دسترسی پیدا کنید و محدودیت‌ها را بردارید.'
  },
  'premium.benefitsInclude': {
    en: 'Benefits include:',
    ja: '特典内容：',
    es: 'Beneficios incluyen:',
    zh: '特典内容：',
    fa: 'مزایا شامل:'
  },
  'premium.unlimitedEntriesBenefit': {
    en: 'Unlimited diary entries',
    ja: '無制限の日記エントリー',
    es: 'Entradas ilimitadas',
    zh: '无限日记条目',
    fa: 'یادداشت‌های نامحدود'
  },
  'premium.photoGalleryBenefit': {
    en: 'Unlimited photo gallery',
    ja: '無制限のフォトギャラリー',
    es: 'Galería de fotos ilimitada',
    zh: '无限照片库',
    fa: 'گالری عکس نامحدود'
  },
  'premium.growthTrackingBenefit': {
    en: 'Advanced growth tracking',
    ja: '高度な成長追跡',
    es: 'Seguimiento de crecimiento avanzado',
    zh: '高级成长跟踪',
    fa: 'پیگیری پیشرفته رشد'
  },
  'premium.prioritySupportBenefit': {
    en: 'Priority support',
    ja: '優先サポート',
    es: 'Soporte prioritario',
    zh: '优先支持',
    fa: 'پشتیبانی اولویت‌دار'
  },
  'premium.subscribeNow': {
    en: 'Subscribe Now',
    ja: '今すぐ購読',
    es: 'Suscríbete ahora',
    zh: '立即订阅',
    fa: 'همین حالا مشترک شوید'
  },
  'premium.currentPlan': {
    en: 'Current Plan',
    ja: '現在のプラン',
    es: 'Plan actual',
    zh: '当前计划',
    fa: 'طرح فعلی'
  },
  'premium.freePlan': {
    en: 'Free',
    ja: '無料',
    es: 'Gratis',
    zh: '免费',
    fa: 'رایگان'
  },
  'premium.premiumPlan': {
    en: 'Premium',
    ja: 'プレミアム',
    es: 'Premium',
    zh: '高级版',
    fa: 'ویژه'
  },
  'premium.premiumFeature': {
    en: 'Premium Feature',
    ja: 'プレミアム機能',
    es: 'Función Premium',
    zh: '高级功能',
    fa: 'ویژگی حساب ویژه'
  },
  'premium.freePlanDescription': {
    en: 'Basic features with 30 free entries',
    ja: '基本機能に30件の無料エントリー',
    es: 'Funciones básicas con 30 entradas gratuitas',
    zh: '基本功能带有30个免费条目',
    fa: 'ویژگی‌های پایه با ۳۰ یادداشت رایگان'
  },
  'premium.premiumPlanDescription': {
    en: 'All features with unlimited entries',
    ja: 'すべての機能に無制限のエントリー',
    es: 'Todas las funciones con entradas ilimitadas',
    zh: '所有功能带有无限条目',
    fa: 'تمام ویژگی‌ها با یادداشت‌های نامحدود'
  },
  'premium.recommended': {
    en: 'Recommended',
    ja: 'おすすめ',
    es: 'Recomendado',
    zh: '推荐',
    fa: 'پیشنهاد شده'
  },
  'premium.subscriptionPlans': {
    en: 'Subscription Plans',
    ja: 'サブスクリプションプラン',
    es: 'Planes de suscripción',
    zh: '订阅计划',
    fa: 'طرح‌های اشتراک'
  },
  'premium.premiumFeatures': {
    en: 'Premium Features',
    ja: 'プレミアム機能',
    es: 'Funciones premium',
    zh: '高级功能',
    fa: 'ویژگی‌های حساب ویژه'
  },
  'premium.growthStatistics': {
    en: 'Track Your Baby\'s Growth',
    ja: '赤ちゃんの成長を追跡',
    es: 'Seguimiento de crecimiento',
    zh: '跟踪宝宝的成长',
    fa: 'پیگیری رشد کودک شما'
  },
  'premium.growthStatisticsDescription': {
    en: 'Monitor height, weight, and development metrics with visual charts',
    ja: '身長、体重、発育指標をビジュアルチャートで監視',
    es: 'Monitorea la altura, el peso y los indicadores de desarrollo con gráficos visuales',
    zh: '通过视觉图表监控身高、体重和发育指标',
    fa: 'پیگیری قد، وزن و شاخص‌های رشد با نمودارهای تصویری'
  },
  'premium.viewSampleStatistics': {
    en: 'View Statistics',
    ja: '統計を見る',
    es: 'Ver estadísticas',
    zh: '查看统计',
    fa: 'مشاهده آمار'
  },
  'premium.freePlanEntryLimit': {
    en: '30 Free Entries',
    ja: '30件の無料エントリー',
    es: '30 Entradas Gratuitas',
    zh: '30个免费条目',
    fa: '۳۰ یادداشت رایگان'
  }
};
